export { StandardUserRegistration } from './StandardUserRegistration';
